var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 385,
    height: 386,
    viewBox: "0 0 385 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46031 178.82C-2.8201 185.335 -2.8201 201.627 8.46031 208.144L89.3783 254.89C78.6498 236.936 72.4825 215.936 72.4825 193.494C72.4825 171.037 78.6588 150.021 89.4054 132.056L8.46031 178.82ZM190.418 73.6996C191.017 73.6913 191.616 73.6861 192.215 73.6861C237.328 73.6861 276.611 98.6509 297.025 135.525V41.4331C297.025 28.4004 282.927 20.2552 271.649 26.7715L190.418 73.6996ZM297.025 251.464C276.611 288.341 237.328 313.304 192.215 313.304C191.634 313.304 191.051 313.3 190.467 313.291L271.649 360.192C282.927 366.709 297.025 358.561 297.025 345.53V251.464Z",
    fill: "#34A853",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.93 195.708C311.943 194.97 311.95 194.234 311.95 193.497C311.95 148.465 287.119 109.234 250.415 88.7664H344.327C357.353 88.7664 365.491 102.873 358.979 114.16L311.93 195.708ZM253.969 296.163C235.938 307.044 214.807 313.307 192.217 313.307C169.83 313.307 148.877 307.156 130.954 296.457L177.725 377.516C184.237 388.802 200.518 388.802 207.027 377.516L253.969 296.163ZM72.4959 195.136L25.7728 114.16C19.2608 102.873 27.4013 88.7664 40.4251 88.7664H134.02C97.3137 109.234 72.4824 148.465 72.4824 193.497C72.4824 194.043 72.4891 194.592 72.4959 195.136Z",
    fill: "#FBBC04",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.54 207.956C387.82 201.439 387.82 185.148 376.54 178.633L295.102 131.583C305.952 149.611 312.193 170.73 312.193 193.307C312.193 215.868 305.963 236.971 295.129 254.988L376.54 207.956ZM194.54 313.101C193.848 313.112 193.154 313.117 192.461 313.117C147.584 313.117 108.477 288.414 87.9727 251.856V345.342C87.9727 358.374 102.073 366.521 113.354 360.004L194.54 313.101ZM194.594 73.5188L113.354 26.5837C102.073 20.0674 87.9727 28.2127 87.9727 41.2453V134.759C108.477 98.2029 147.584 73.4999 192.461 73.4999C193.175 73.4999 193.884 73.5051 194.594 73.5188Z",
    fill: "#EA4335",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.027 9.44546C200.518 -1.84087 184.237 -1.84087 177.723 9.44546L130.927 90.5504C148.855 79.8404 169.819 73.686 192.215 73.686C214.819 73.686 235.958 79.9527 253.994 90.8446L207.027 9.44546ZM311.927 191.254C311.943 191.999 311.95 192.748 311.95 193.495C311.95 238.506 287.143 277.721 250.466 298.196H344.329C357.353 298.196 365.491 284.087 358.982 272.801L311.927 191.254ZM133.968 298.196C97.2889 277.721 72.4846 238.506 72.4846 193.495C72.4846 192.937 72.4869 192.379 72.4936 191.825L25.7728 272.801C19.2608 284.087 27.4013 298.196 40.4251 298.196H133.968Z",
    fill: "#4285F4",
    fillOpacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.59 112.857C216.205 75.1787 149.735 80.5678 111.988 124.853C119.563 116.154 132.74 115.139 141.561 122.626C150.451 130.174 151.544 143.505 144.002 152.399L144.004 152.402C166.574 125.78 206.394 122.449 233.067 144.899C233.135 144.958 233.203 145.016 233.27 145.075C242.163 152.624 255.484 151.529 263.028 142.634C270.571 133.737 269.479 120.406 260.588 112.857H260.59Z",
    fill: "url(#paint0_linear_370_1253)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.799 125.067C74.1644 169.451 79.523 235.912 123.71 273.696L124.003 273.946C115.112 266.396 114.02 253.065 121.563 244.168C129.093 235.287 142.385 234.182 151.276 241.691C124.683 219.074 121.39 179.196 143.894 152.52C143.93 152.48 143.964 152.44 143.998 152.399C151.544 143.502 150.451 130.171 141.558 122.624C132.668 115.075 119.342 116.17 111.799 125.067Z",
    fill: "url(#paint1_linear_370_1253)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.007 273.943V273.945C168.37 311.603 234.789 306.24 272.549 262.02L272.795 261.732C265.251 270.63 251.928 271.723 243.035 264.175C234.144 256.628 233.052 243.297 240.596 234.4C217.99 261.062 178.083 264.364 151.409 241.797C151.382 241.774 151.355 241.75 151.325 241.727C142.435 234.177 129.111 235.273 121.568 244.168C114.027 253.065 115.119 266.396 124.007 273.943Z",
    fill: "url(#paint2_linear_370_1253)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.884 113.103L260.676 112.927C269.49 120.489 270.551 133.761 263.032 142.629C255.514 151.497 242.256 152.613 233.365 145.149C259.942 167.795 263.197 207.7 240.629 234.362C240.618 234.374 240.607 234.387 240.595 234.401C233.052 243.298 234.147 256.629 243.037 264.176C251.928 271.723 265.251 270.63 272.792 261.733L272.795 261.735L272.907 261.6C310.418 217.214 305.025 150.849 260.884 113.103Z",
    fill: "url(#paint3_linear_370_1253)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_370_1253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 142,
    width: 103,
    height: 102
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.587,
    cy: 193.318,
    rx: 50.6807,
    ry: 50.6154,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_370_1253)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.587,
    cy: 193.318,
    rx: 50.6807,
    ry: 50.6154,
    fill: "url(#paint4_linear_370_1253)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.304 156.111C171.68 156.548 170.864 157.635 170.49 158.528C169.702 160.412 169.606 166.732 170.319 169.817L170.803 171.911L166.897 177.345C162.504 183.46 162.309 184.235 164.168 188.221C166.241 192.668 170.939 196.871 179.066 201.547C187.113 206.177 191.596 212.583 192.078 220.138L192.333 224.151L190.405 221.215C187.215 216.358 181.27 211.932 171.284 206.979C166.856 204.783 165.029 203.548 162.498 201.043C160.74 199.303 158.731 196.733 158.032 195.332C156.572 192.406 156.281 192.685 155.837 197.444C155.481 201.24 156.677 206.765 158.562 210.044C160.903 214.114 163.764 216.896 169.597 220.775C175.677 224.819 179.192 228.338 181.159 232.351C182.639 235.37 183.732 240.714 183.257 242.607C182.93 243.906 182.871 243.862 180.932 240.865C177.833 236.077 173.105 231.73 165.892 227.036C158.672 222.338 154.583 218.744 152.163 214.969L150.572 212.487L150.429 215.45C150.231 219.535 151.448 224.944 153.5 229.109C154.872 231.892 156.032 233.335 159.171 236.163C161.45 238.216 163.727 240.795 164.562 242.271L166.008 244.825H175.101H184.193L187.423 240.568C196.081 229.161 200.642 219.511 201.967 209.8C203.063 201.764 202.783 202.284 206.115 202.1C209.832 201.895 213.609 202.726 215.844 204.24L217.602 205.432L218.979 202.386C220.577 198.854 221.929 194.998 221.929 193.974C221.929 192.987 221.116 193.082 219.142 194.301C217.708 195.185 216.974 195.3 214.212 195.069C210.134 194.727 205.689 193.093 204.405 191.462C202.857 189.496 203.107 187.152 205.076 185.186C207.074 183.191 208.157 183.128 211.076 184.836C212.302 185.554 214.094 186.273 215.059 186.434C216.759 186.718 216.813 186.791 216.772 188.778C216.747 190.001 216.952 190.829 217.279 190.829C217.582 190.829 218.771 189.87 219.923 188.698C221.492 187.102 222.499 186.502 223.94 186.31C227.219 185.87 229.383 183.887 230.013 180.743C230.308 179.269 230.213 179.167 226.975 177.468L223.633 175.715L227.165 175.91C229.107 176.017 230.696 175.907 230.696 175.666C230.696 174.489 225.801 170.658 221.915 168.793C218.644 167.223 217.454 166.377 216.781 165.145C214.241 160.493 206.705 157.802 193.358 156.78C189.65 156.496 184.314 156.05 181.501 155.79C174.613 155.153 173.625 155.187 172.304 156.111ZM183.45 162.203C181.255 164.127 177.586 166.506 176.814 166.506C175.913 166.506 174.682 165.1 174.682 164.071C174.682 163.573 174.896 162.603 175.157 161.917C175.623 160.693 175.723 160.669 180.393 160.689L185.154 160.708L183.45 162.203ZM191.659 168.148C190.949 171.679 191.59 174.012 194.163 177.264C195.191 178.563 196.161 180.286 196.317 181.093C196.473 181.899 196.723 183.195 196.873 183.972C197.057 184.929 196.901 186.733 196.901 186.733C196.901 186.733 195.862 185.422 195.308 184.559C194.814 183.786 193.262 182.252 191.859 181.149C188.765 178.715 187.826 177.357 187.486 174.825C187.059 171.644 187.724 169.521 189.883 167.183C190.977 165.997 191.95 165.104 192.044 165.199C192.139 165.294 191.966 166.621 191.659 168.148ZM208.56 166.595C212.021 167.986 212.67 168.859 211.533 170.592C210.015 172.907 206.689 172.039 201.56 167.99C200.171 166.894 199.036 165.752 199.036 165.452C199.036 164.562 205.401 165.326 208.56 166.595ZM180.448 182.251C181.64 184.942 185.007 188.31 188.503 190.307C191.723 192.148 195.866 196.471 197.118 199.297C197.641 200.477 198.192 202.502 198.343 203.797L198.618 206.152L197.091 204.347C195.169 202.077 189.671 197.95 184.911 195.205C179.775 192.244 178.119 190.901 176.544 188.423C174.478 185.173 174.609 181.852 176.987 177.152L178.806 173.56L179.134 176.793C179.315 178.571 179.906 181.027 180.448 182.251ZM205.245 211.363C205.527 216.896 204.523 223.128 202.411 228.957C200.669 233.765 198.385 237.467 194.482 241.803C192.968 243.485 191.731 244.908 191.733 244.965C191.744 245.286 205.23 245 205.744 244.668C206.693 244.055 209.042 239.127 210.315 235.079C211.923 229.965 211.953 220.855 210.379 215.881C209.272 212.383 206.52 207.326 205.556 207.018C205.174 206.896 205.083 208.175 205.245 211.363ZM217.375 220.259C218.446 226.654 217.304 231.796 213.216 238.987C209.517 245.493 209.344 245.044 215.612 245.21L220.963 245.352L221.459 244.05C222.543 241.201 223.104 233.324 222.5 229.439C221.837 225.178 219.957 220.618 218.181 218.96L216.967 217.827L217.375 220.259ZM228.976 233.955C228.963 237.223 228.735 238.253 227.385 241.127C226.518 242.973 225.883 244.558 225.974 244.649C226.065 244.741 228.426 244.872 231.219 244.941L236.297 245.068L236.22 242.777C236.116 239.687 234.285 235.885 231.387 232.739L228.991 230.139L228.976 233.955ZM147.075 236.78C147.241 239.311 147.687 242.123 148.066 243.028C148.73 244.617 148.869 244.685 152.098 244.989C156.708 245.424 161.531 245.39 161.531 244.923C161.531 244.215 157.928 241.113 154.013 238.452C151.887 237.007 149.585 235.013 148.899 234.02C148.211 233.026 147.452 232.206 147.21 232.196C146.96 232.185 146.901 234.146 147.075 236.78Z",
    fill: "url(#paint5_linear_370_1253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.066 201.547C170.939 196.871 166.241 192.668 164.168 188.221C162.974 185.662 162.626 184.428 163.694 182.252C166.787 177.153 170.064 174.197 178.806 173.56L176.987 177.152C176.359 178.394 175.886 179.541 175.571 180.615C175.571 180.615 172.597 189.198 175.955 192.29C177.774 193.964 180.178 195.559 182.631 197.187C186.236 199.579 189.95 202.043 192.077 204.937C195.651 209.802 194.786 216.434 192.333 224.151L192.078 220.138C191.596 212.583 187.113 206.177 179.066 201.547Z",
    fill: "url(#paint6_linear_370_1253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.411 228.957C204.523 223.128 205.527 216.896 205.245 211.363C205.083 208.175 205.174 206.896 205.556 207.018C205.556 207.018 209.564 219.288 206.641 228.773C203.207 239.921 191.733 244.965 191.733 244.965C191.731 244.908 192.968 243.485 194.482 241.803C198.385 237.467 200.669 233.765 202.411 228.957Z",
    fill: "url(#paint7_linear_370_1253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.216 238.987C217.304 231.796 218.446 226.654 217.375 220.259L216.967 217.827C216.967 217.827 221.078 225.882 220.28 231.204C218.544 242.777 210.72 244.568 210.72 244.568C210.363 243.968 211.069 242.737 212.555 240.143C212.76 239.785 212.981 239.4 213.216 238.987Z",
    fill: "url(#paint8_linear_370_1253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.562 210.044C156.677 206.765 155.481 201.24 155.837 197.444C156.095 194.675 156.301 193.424 156.716 193.436C156.716 193.436 159.62 206.61 165.891 211.363C168.12 213.053 170.229 214.151 172.452 215.309C175.604 216.951 178.985 218.711 183.262 222.449C189.107 227.556 191.055 235.533 191.055 235.533C189.935 237.176 188.726 238.852 187.423 240.568L184.193 244.825L182.531 244.825L183.257 242.607C183.732 240.714 182.639 235.37 181.159 232.351C179.192 228.338 175.677 224.819 169.597 220.775C163.764 216.896 160.903 214.114 158.562 210.044Z",
    fill: "url(#paint9_linear_370_1253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.429 215.45L150.572 212.487C150.572 212.487 150.871 222.599 158.562 228.774C160.494 230.325 162.214 231.499 163.868 232.628C166.328 234.307 168.641 235.885 171.283 238.454C173.667 240.773 176.93 244.827 176.93 244.827L175.101 244.825H166.008L164.562 242.271C163.727 240.795 161.45 238.216 159.171 236.163C156.032 233.335 154.872 231.892 153.5 229.109C151.448 224.944 150.231 219.535 150.429 215.45Z",
    fill: "url(#paint10_linear_370_1253)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.976 233.955C228.963 237.223 228.735 238.253 227.385 241.127C226.518 242.973 225.883 244.558 225.974 244.649C225.974 244.649 230.353 243.61 231.727 238.988C232.888 235.08 228.991 230.139 228.991 230.139L228.976 233.955Z",
    fill: "url(#paint11_linear_370_1253)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.111 184.265C193.759 184.688 194.826 185.387 196.872 186.695C196.216 185.907 195.862 185.422 195.308 184.559C194.814 183.786 193.262 182.252 191.859 181.149C188.765 178.715 187.826 177.357 187.486 174.825C187.059 171.644 187.724 169.521 189.883 167.183C190.89 166.092 191.793 165.25 192.005 165.196C192.031 165.198 192.044 165.199 192.044 165.199C192.037 165.192 192.023 165.191 192.005 165.196C191.514 165.149 186.538 164.809 183.992 170.156C182.603 173.074 183.128 178.586 187.158 180.857C189.274 182.05 190.392 182.665 191.07 183.038C191.592 183.326 191.853 183.469 192.108 183.623C192.363 183.776 192.612 183.939 193.111 184.265Z",
    fill: "url(#paint12_linear_370_1253)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.046 165.384C199.046 165.384 195.926 177.938 205.18 179.398C210.112 180.175 214.011 174.31 213.037 170.419C212.769 169.348 211.717 168.389 211.717 168.389C212.187 169.003 212.108 169.717 211.533 170.592C210.015 172.907 206.689 172.039 201.56 167.99C198.99 165.961 199.046 165.384 199.046 165.384Z",
    fill: "url(#paint13_linear_370_1253)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_370_1253",
    x1: 208.817,
    y1: 113.509,
    x2: 129.554,
    y2: 136.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285F4",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_370_1253",
    x1: 112.45,
    y1: 176.87,
    x2: 135.083,
    y2: 256.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F9D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F9D58",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_370_1253",
    x1: 175.78,
    y1: 273.293,
    x2: 255.043,
    y2: 250.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B400",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_370_1253",
    x1: 272.171,
    y1: 209.952,
    x2: 249.52,
    y2: 130.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB4437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB4437",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_370_1253",
    x1: 229.331,
    y1: 159.153,
    x2: 167.33,
    y2: 223.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF5A02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_370_1253",
    x1: 229.331,
    y1: 240.138,
    x2: 169.881,
    y2: 159.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_370_1253",
    x1: 215.018,
    y1: 177.276,
    x2: 200.887,
    y2: 164.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_370_1253",
    x1: 215.018,
    y1: 177.276,
    x2: 200.887,
    y2: 164.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_370_1253",
    x1: 215.018,
    y1: 177.276,
    x2: 200.887,
    y2: 164.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_370_1253",
    x1: 215.018,
    y1: 177.276,
    x2: 200.887,
    y2: 164.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_370_1253",
    x1: 215.018,
    y1: 177.276,
    x2: 200.887,
    y2: 164.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_370_1253",
    x1: 215.018,
    y1: 177.276,
    x2: 200.887,
    y2: 164.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_370_1253",
    x1: 215.018,
    y1: 177.276,
    x2: 200.887,
    y2: 164.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_370_1253",
    x1: 215.018,
    y1: 177.276,
    x2: 200.887,
    y2: 164.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECDE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ad5154124eeb624055c18df76fdb5386.svg";
export { ForwardRef as ReactComponent };